import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { FowlFlingBonusTransitionComponent } from "components/bonus/fling/fowl-fling-bonus-transition-component";
import { FowlEggPickBonusComponent } from "components/bonus/pick/fowl-egg-pick-bonus-component";
import { gameLayers } from "game-layers";
import { FowlJackpotBonusResult } from "model/results/fowl-jackpot-bonus-result";
import { FowlPickBonusResult } from "model/results/fowl-pick-bonus-result";
import { SlingoGameProgressResult } from "slingo/model/results/slingo-game-progress-result";
import { BigWinComponent } from "slotworks/components/bigwin/big-win-component";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class FowlExitPickBonusState extends State {
    public onEnter(): void {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        const pickResult = record.getFirstResultOfType(FowlPickBonusResult);
        pickResult.played = true;

        const jackpotResult = record.getFirstResultOfType(FowlJackpotBonusResult);

        const totalStake = gameplay.getLatestResultOfType(SlingoGameProgressResult).totalStake;

        new Sequence([
            () => Services.get(SoundService).customEventContract("stop_bonus_music"),
            () => Components.get(BigWinComponent).showWin(pickResult.cashWon, totalStake),
            () =>
                Contract.wrap(() => {
                    let unplayedBonusWin = 0;
                    record.results.forEach(result => {
                        if (result instanceof BonusResult && !result.played) {
                            unplayedBonusWin += result.cashWon;
                        }
                    });
                    Services.get(TransactionService).setTotalWin(gameplay.getTotalWin() - unplayedBonusWin);
                }),
            () => {
                if (jackpotResult) {
                    return Components.get(FowlFlingBonusTransitionComponent).playPickOutro();
                }
                return Contract.empty();
            },
            () => gameLayers.ScreenFade.setScene("black"),
            () => gameLayers.EggPickBonus.defaultScene(),
            () => Components.get(FowlEggPickBonusComponent).exit(),
        ]).then(() => this.complete());
    }
}
